import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { FaqContent, faqData } from '../faq-content';

@Component({
  selector: 'lib-faq-list',
  templateUrl: './faq-list.component.html',
  styleUrls: ['./faq-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class FaqListComponent {
  readonly faqContent: WritableSignal<FaqContent[]> = signal<FaqContent[]>(faqData);

  changeVisibility(item: FaqContent): void {
    this.faqContent.update((data: FaqContent[]) =>
      data.map((faqItem: FaqContent) => {
        if (faqItem.id === item.id) return { ...faqItem, isVisible: !faqItem.isVisible };
        return { ...faqItem, isVisible: false };
      })
    );
  }
}
